import { LegalLayout, Clause, ContactClause } from "./LegalLayout";
import { useLang } from "../i18n/LanguageContext";

export default function TermsOfService() {
  const { t } = useLang();
  const tm = t.terms;
  return (
    <LegalLayout title={tm.title} updated={tm.updated} testId="terms-page">
      {tm.clauses.map((c, i) => (
        <Clause key={i} heading={c.h}>
          {c.body.map((para, j) => <p key={j}>{para}</p>)}
        </Clause>
      ))}
      <Clause heading={t.brand.termsEngagement.h}>
        <p data-testid="terms-engagement">{t.brand.termsEngagement.body}</p>
      </Clause>
      <ContactClause heading={tm.contactHeading} lead={tm.contactLead} />
    </LegalLayout>
  );
}
